export const CollectionDefaultValue = [
  {
    id: 1,
    title: "KidzTokyo",
    banner: "../../../assets/img/default/collection/1.jpg",
    price: 325,
    owner: {
      id: 1,
      name: "Oxygen",
      ava: "../../../assets/img/default/nft/smile_1.png",
      wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    },
    creator: {
      id: 1,
      name: "Cinematic",
      wallet: "0x9621d6c9417E95e257f9318288377a424C1EffEb",
    },
  },
  {
    id: 2,
    title: "Robotos NFT",
    banner: "../../../assets/img/default/collection/2.png",
    price: 325,
    owner: {
      id: 1,
      name: "Oxygen",
      ava: "../../../assets/img/default/nft/smile_1.png",
      wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    },
    creator: {
      id: 3,
      name: "Cinematic",
      wallet: "0x9621d6c9417E95e257f9318288377a424C1EffEb",
    },
  },
  {
    id: 3,
    title: "Pixel Punk",
    banner: "../../../assets/img/default/collection/3.jpg",
    price: 325,
    owner: {
      id: 1,
      name: "Oxygen",
      ava: "../../../assets/img/default/nft/smile_1.png",
      wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    },
    creator: {
      id: 1,
      name: "Cinematic",
      wallet: "0x9621d6c9417E95e257f9318288377a424C1EffEb",
    },
  },
  {
    id: 4,
    title: "Robotos",
    banner: "../../../assets/img/default/collection/4.png",
    price: 325,
    owner: {
      id: 1,
      name: "Oxygen",
      ava: "../../../assets/img/default/nft/smile_1.png",
      wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    },
    creator: {
      id: 1,
      name: "Cinematic",
      wallet: "0x9621d6c9417E95e257f9318288377a424C1EffEb",
    },
  },
  {
    id: 5,
    title: "Robotos NFT",
    banner: "../../../assets/img/default/collection/2.png",
    price: 325,
    owner: {
      id: 1,
      name: "Oxygen",
      ava: "../../../assets/img/default/nft/smile_1.png",
      wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    },
    creator: {
      id: 3,
      name: "Cinematic",
      wallet: "0x9621d6c9417E95e257f9318288377a424C1EffEb",
    },
  },
  {
    id: 1,
    title: "KidzTokyo",
    banner: "../../../assets/img/default/collection/1.jpg",
    price: 325,
    owner: {
      id: 1,
      name: "Oxygen",
      ava: "../../../assets/img/default/nft/smile_1.png",
      wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    },
    creator: {
      id: 1,
      name: "Cinematic",
      wallet: "0x9621d6c9417E95e257f9318288377a424C1EffEb",
    },
  },
  {
    id: 2,
    title: "Robotos NFT",
    banner: "../../../assets/img/default/collection/2.png",
    price: 325,
    owner: {
      id: 1,
      name: "Oxygen",
      ava: "../../../assets/img/default/nft/smile_1.png",
      wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    },
    creator: {
      id: 3,
      name: "Cinematic",
      wallet: "0x9621d6c9417E95e257f9318288377a424C1EffEb",
    },
  },
  {
    id: 3,
    title: "Pixel Punk",
    banner: "../../../assets/img/default/collection/3.jpg",
    price: 325,
    owner: {
      id: 1,
      name: "Oxygen",
      ava: "../../../assets/img/default/nft/smile_1.png",
      wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    },
    creator: {
      id: 1,
      name: "Cinematic",
      wallet: "0x9621d6c9417E95e257f9318288377a424C1EffEb",
    },
  },
  {
    id: 4,
    title: "Robotos",
    banner: "../../../assets/img/default/collection/4.png",
    price: 325,
    owner: {
      id: 1,
      name: "Oxygen",
      ava: "../../../assets/img/default/nft/smile_1.png",
      wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    },
    creator: {
      id: 1,
      name: "Cinematic",
      wallet: "0x9621d6c9417E95e257f9318288377a424C1EffEb",
    },
  },
  {
    id: 5,
    title: "Robotos NFT",
    banner: "../../../assets/img/default/collection/2.png",
    price: 325,
    owner: {
      id: 1,
      name: "Oxygen",
      ava: "../../../assets/img/default/nft/smile_1.png",
      wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    },
    creator: {
      id: 3,
      name: "Cinematic",
      wallet: "0x9621d6c9417E95e257f9318288377a424C1EffEb",
    },
  },
];
